import request, { queryWithSilentSilentSignin } from '@/utils/request'
import { log } from 'devtools-detector'

const url_prefix = process.env.VUE_APP_API_URL

const backend_url = '/backend-api/assistant'

export async function uploadFile(file, id, knowledgeId) {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  if (id) {
    formData.append('assistant_id', id)
  }
  if (knowledgeId) {
    formData.append('knowledge_id', knowledgeId)
  }
  return request(
    {
      url: `${url_prefix}${backend_url}/file/upload`,
      method: 'post',
      data: formData,
      timeout: 1000 * 90
    },
    {
      repeatRequestCancel: false,
      loading: false,
      errorMessageShow: false
    }
  )
}

// 云知识库文件上传
export async function uploadFileCloud(data) {
  return request({
    url: `${url_prefix}${backend_url}/file/upload_yun_link`,
    method: 'post',
    data
  })
}

export async function deleteFile(data) {
  return request({
    url: `${url_prefix}${backend_url}/file/delete`,
    method: 'post',
    data
  })
}

export async function batchDelete(data) {
  return request({
    url: `${url_prefix}${backend_url}/file/delete/list`,
    method: 'post',
    data
  })
}

export async function addSeed(data) {
  return request({
    url: `${url_prefix}${backend_url}/file/add_seed`,
    method: 'post',
    data
  })
}
export async function updateSeed(data) {
  return request({
    url: `${url_prefix}${backend_url}/file/update_seed`,
    method: 'post',
    data
  })
}
export async function getFileAuthInfo(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/file/auth_account/info`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
export async function cancelFileAuth(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/file/auth_account/delete`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
export async function getFileAuthAdd(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/file/auth_account/add`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
export async function pullFileData(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/file/auth_account/pull`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

export async function createAssistant(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/create`,
      method: 'post',
      data,
      timeout: 1000 * 60
    },
    {
      loading: false
    }
  )
}

export async function cloneAssistant(data) {
  console.log('cloneAssistant', data)
  return request(
    {
      url: `${url_prefix}${backend_url}/clone_assistant`,
      method: 'post',
      data,
      timeout: 1000 * 60
    },
    {
      loading: false,
      errorMessageShow: false
    }
  )
}

// 客户端配置数据
export async function getCreateGmlsConfig() {
  return queryWithSilentSilentSignin(
    {
      url: `${url_prefix}/backend-api/v1/operation_data?tag=create_glms_config`,
      method: 'get'
    },
    {
      withToken: false,
      loading: false,
      errorMessageShow: false
    }
  )
}

export async function getAssistantInfo(id, fr) {
  if (fr === 'loadingFalse') {
    return request(
      {
        url: `${url_prefix}${backend_url}/info`,
        method: 'get',
        params: {
          assistant_id: id
        }
      },
      {
        loading: false
      }
    )
  }
  return request(
    {
      url: `${url_prefix}${backend_url}/info`,
      method: 'get',
      params: {
        assistant_id: id,
        fr: fr
      }
    },
    { loading: false }
  )
}

export async function updateAssistantInfo(data) {
  const starter_prompts = data.starter_prompts?.filter(item => item !== '')
  const assistantInfo = { ...data, starter_prompts }

  return request(
    {
      url: `${url_prefix}${backend_url}/update`,
      method: 'post',
      data: assistantInfo
    },
    {
      loading: false
    }
  )
}

export async function saveDraft(data) {
  const starter_prompts = data.starter_prompts.filter(item => item !== '')
  const assistantInfo = { ...data, starter_prompts }

  return request(
    {
      url: `${url_prefix}${backend_url}/save_draft`,
      method: 'post',
      data: assistantInfo
    },
    {
      loading: false
    }
  )
}

export async function updateAvatar(data) {
  return request(
    {
      url: `${url_prefix}${backend_url}/gen_avatar`,
      method: 'post',
      data,
      timeout: 1000 * 60
    },
    {
      repeatRequestCancel: false,
      loading: false
    }
  )
}

export async function getAssistantList(data) {
  // data: {page, page_size} page从1开始
  return request({
    url: `${url_prefix}${backend_url}/list`,
    method: 'post',
    data
  })
}

export async function getAssistantFeedList(data) {
  // data: {page, page_size} page从1开始
  return request({
    url: `${url_prefix}/feed-api/assistant/feed_list`,
    method: 'get',
    params: data
  })
}

export async function publishAssistant(data) {
  // data: {assistant_id}
  return request({
    url: `${url_prefix}${backend_url}/publish`,
    method: 'post',
    data
  })
}

export async function deleteAssistant(data) {
  return request({
    url: `${url_prefix}${backend_url}/delete`,
    method: 'post',
    data
  })
}

export async function getDigitalInfo(data) {
  return request({
    url: `${url_prefix}/backend-api/assistant/create_channel`,
    method: 'get',
    params: data
  })
}

export async function getDigitalActors(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/assistant/get_digital_actors`,
      method: 'get',
      params: data
    },
    {
      loading: false
    }
  )
}

export async function digitalHeartBeat(data) {
  return request({
    url: `${url_prefix}/backend-api/assistant/heart_beat`,
    method: 'get',
    params: data
  })
}

export async function interruptDigitalActor(data) {
  return request({
    url: `${url_prefix}/backend-api/assistant/interrupt_digital_actors`,
    method: 'get',
    params: data
  })
}

export async function freeChannel(data) {
  return request({
    url: `${url_prefix}/backend-api/assistant/free_channel`,
    method: 'get',
    params: data
  })
}

export async function getSidebarList(data) {
  return request(
    {
      url: `${url_prefix}/feed-api/assistant/list`,
      method: 'get',
      params: data
    },
    {
      repeatRequestCancel: false,
      loading: false
    }
  )
}
// 获取最近使用的智能体列表
export async function getMenuList(data) {
  return request(
    {
      url: `${url_prefix}/feed-api/assistant_top/v4/recent_list`,
      method: 'get',
      params: data
    },
    {
      repeatRequestCancel: false,
      loading: false
    }
  )
}
// 置顶
export async function fixedOnTop(data) {
  return request({
    url: `${url_prefix}/feed-api//assistant_top/assistant`,
    method: 'post',
    data
  })
}
// 取消置顶
export async function cancelFixedOnTop(data) {
  return request({
    url: `${url_prefix}/feed-api//assistant_top/assistant`,
    method: 'PUT',
    data
  })
}
// 移除对话
export async function removeConversation(data) {
  return request({
    url: `${url_prefix}/feed-api/assistant_top/assistant`,
    method: 'DELETE',
    data
  })
}

export async function deleteFromSidebar(assistant_id) {
  return request({
    url: `${url_prefix}/feed-api/assistant/show/${assistant_id}`,
    method: 'delete'
  })
}

export async function fixedOnSidebar(assistant_id) {
  return request({
    url: `${url_prefix}/feed-api/assistant/show/${assistant_id}`,
    method: 'post'
  })
}

export async function getRecentList(data) {
  return request({
    url: `${url_prefix}/feed-api/assistant/recent_list`,
    method: 'get',
    params: data
  })
}

export async function getOfficalRecommendList(data) {
  return request({
    url: `${url_prefix}/feed-api/assistant/feed_group`,
    method: 'get',
    params: data
  })
}

export function getRecommendGroup() {
  return request(
    {
      url: `${url_prefix}/feed-api/assistant/recommend_group`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}
// 获取 @ 智能体列表
export async function getAtAssistantList(data) {
  return request(
    {
      url: `${url_prefix}/feed-api/assistant/mention_list`,
      method: 'get',
      params: data
    },
    {
      loading: false
    }
  )
}

export async function checkUrl(data) {
  return request({
    url: `${url_prefix}${backend_url}/action/get_url`,
    method: 'post',
    data
  })
}

export async function templateParse(data) {
  return request({
    url: `${url_prefix}/action-api/template/parse`,
    method: 'post',
    data
  })
}

export async function testCall(data) {
  return request({
    url: `${url_prefix}/action-api/test/call`,
    method: 'post',
    data,
    timeout: 5 * 60 * 1000 // 5分钟
  })
}

export async function createAction(data) {
  return request({
    url: `${url_prefix}/action-api/action/create`,
    method: 'post',
    data
  })
}

export async function checkAction(data) {
  return request({
    url: `${url_prefix}${backend_url}/action/action_check`,
    method: 'post',
    data
  })
}

export async function addAction(data) {
  return request({
    url: `${url_prefix}${backend_url}/action/add`,
    method: 'post',
    data
  })
}

export async function deleteAction(data) {
  return request({
    url: `${url_prefix}${backend_url}/action/delete`,
    method: 'post',
    data
  })
}

export async function getFileStatus(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/assistant/file/list`,
      method: 'post',
      data
    },
    {
      repeatRequestCancel: false,
      loading: false
    }
  )
}

export async function genFileId(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/assistant/file/gen_id`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
export async function fileRename(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/assistant/file/rename`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
